import Query from '../../components/Report';

export const getCTRAverage = new Query('ctr-average');
